import { render } from "./GameRoomLoading.vue?vue&type=template&id=c0fece48&ts=true"
import script from "./GameRoomLoading.vue?vue&type=script&lang=ts"
export * from "./GameRoomLoading.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__